import { Box } from '@mui/joy';
import { useParams } from 'react-router-dom';
import Loader from '../../components/core/Loader';
import Post from '../../components/core/post/Post';
import Main from '../../components/layout/Main';
import usePost from '../../hooks/usePost';
import { useUser } from '../../hooks/useUser';

export const PostPage = () => {
  const userQuery = useUser();
  const { postID } = useParams<{ postID: string }>();
  const postQuery = usePost(postID!);

  const user = userQuery.data;
  // const isAdmin = useMemo(() => {
  //   return user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN';
  // }, [user]);

  if (!postQuery.isSuccess) {
    return <Loader />;
  }

  if (!postQuery.data) {
    return <Box>Oops, deze post bestaat (niet) meer...</Box>;
  }

  return (
    <Main
      contentLeft={null}
      contentRight={null}
      main={
        <Box
          sx={{
            padding: '5rem 1rem 1rem 1rem',
          }}
        >
          <Post
            post={postQuery.data}
            hideQuickNavigate={false}
            refetch={postQuery.refetch}
          />
        </Box>
      }
    />
  );
};
